import styled from "styled-components";

export const UserChatMessageContainer = styled.div`
  ${(props) => props?.theme?.themeConfig?.chatMessages?.userMessage?.styles}

  .voa-blur-effect {
    filter: blur(3px);
  }
`